import { Box, styled } from "@mui/material";

export const Card = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    borderRadius: theme.shape.borderRadius,
    height: 130,
    boxShadow: theme.shadow.boxShadow.sm,
    userSelect: "none",
    overflow: "hidden",

    "&:hover": {
        boxShadow: theme.shadow.boxShadow.lg,
        cursor: "pointer",
    },
}));

export const CardContent = styled(Box)(() => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center",
    alignItems: "flex-start",
}));
